import type { Datastore } from 'util/datastore';
import { useDatastore, useModuleMap } from 'util/datastore';
import { defineModuleMap } from 'util/moduledata';
import type { DataReadOptions } from 'util/stdtypes';
import { getDeploymentConfig } from 'util/util';

export type EmailPermission = {
    status: boolean;
};

export type EmailPermissionModerationDecision = {
    status: boolean;
};

export enum EmailPermissionCategory {
    REPLY = 'reply',
    MODERATIONDECISION = 'moderationDecision',
}

// eslint-disable-next-line module-data-owner -- FIXME: use module name 'email-notification'
const moduleEmailPermissionMap = defineModuleMap<EmailPermission>('USER_GLOBAL', 'notifications', 'emailPermissions');

function getDefaultPermissionsFromSiloConfig(datastore: Datastore, category: EmailPermissionCategory): boolean {
    const siloKey = datastore.getSiloKey();
    const deploymentConfig = getDeploymentConfig();
    const defaultPermissions = siloKey ? deploymentConfig?.siloConfig?.[siloKey]?.defaultNotificationPermissions?.email : null;
    return defaultPermissions ? defaultPermissions[category] : true;
}

export function useEmailNotificationPermission(category: EmailPermissionCategory, options?: DataReadOptions): boolean {
    const datatore = useDatastore();
    const defaultPermission = getDefaultPermissionsFromSiloConfig(datatore, category);
    const permissionModuleMap = useModuleMap(moduleEmailPermissionMap, options);
    return permissionModuleMap?.[category]?.status ?? defaultPermission;
}

export async function setEmailNotificationPermissionAsync({
    datastore,
    category,
    value,
}: {
    datastore: Datastore;
    category: EmailPermissionCategory;
    value: boolean;
}) {
    await datastore.setModuleObjectAsync(moduleEmailPermissionMap, category, { status: value });
}
